import { Box, Button, Chip, Link, Stack, styled, Typography } from '@mui/material';
import { InfoCard } from 'src/pages/Settings/company-info/styled';

export const ClientSegmentsContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(3, 0, 6),
  gap: theme.spacing(2),
  overflow: 'auto',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2.5, 0, 5),
  },
}));

export const ClientSegmentsDescriptor = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1),
}));

export const ClientSegmentsList = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const SegmentCard = InfoCard;

export const SegmentCardHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
  minWidth: 0,
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
}));

export const SegmentName = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  minWidth: 0,
  flex: 1,
}));

export const SegmentHeaderActions = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    marginLeft: 'auto',
  },
}));

export const SitesCountChip = styled(Chip)(({ theme }) => ({
  height: theme.typography.pxToRem(22),
  borderRadius: theme.typography.pxToRem(11),
  backgroundColor: theme.palette.custom.OV.extended.Proactive.colorContainer,
  color: theme.palette.custom.OV.extended.Proactive.onColorContainer,
  fontSize: theme.typography.pxToRem(12),
  fontWeight: 500,
  '& .MuiChip-label': {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

export const SegmentDivider = styled(Box)(({ theme }) => ({
  height: 1,
  backgroundColor: theme.palette.custom.OV.sys.outlineVariant,
  marginBottom: theme.spacing(2),
}));

export const SegmentFieldGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: `${theme.typography.pxToRem(160)} 1fr`,
  gridAutoRows: theme.typography.pxToRem(20),
  rowGap: theme.spacing(1.25),
  columnGap: theme.spacing(2),
  alignItems: 'center',
  minWidth: 0,
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    gridAutoRows: 'auto',
    rowGap: theme.spacing(0.5),
  },
}));

export const SegmentFieldLabel = styled('span')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(13),
  fontWeight: 500,
  color: theme.palette.text.secondary,
  minWidth: 0,
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(1),
    '&:first-of-type': {
      marginTop: 0,
    },
  },
}));

export const SegmentFieldValue = styled('span')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(13),
  fontWeight: 500,
  color: theme.palette.text.primary,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  minWidth: 0,
  [theme.breakpoints.down('sm')]: {
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
  },
}));

export const SegmentLinkRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  minWidth: 0,
  maxWidth: '100%',
  '& .launch-icon': {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
    flexShrink: 0,
    marginLeft: 'auto',
  },
}));

export const SegmentLink = styled(Link)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(13),
  fontWeight: 500,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  minWidth: 0,
  display: 'inline-block',
  color: theme.palette.primary.main,
  [theme.breakpoints.down('sm')]: {
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
  },
}));

export const AddSegmentCard = styled(Button)(({ theme }) => ({
  border: `1px dashed ${theme.palette.custom.OV.sys.outlineVariant}`,
  borderRadius: theme.typography.pxToRem(12),
  padding: theme.spacing(2),
  width: '100%',
  minHeight: theme.typography.pxToRem(56),
  color: theme.palette.primary.main,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    border: `1px dashed ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.action.hover,
  },
  '&.Mui-disabled': {
    opacity: 0.6,
  },
}));

export const EmptyStateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(6, 4),
  gap: theme.spacing(2),
  textAlign: 'center',
}));

export const EmptyStateIconWrap = styled(Box)(({ theme }) => ({
  width: theme.typography.pxToRem(56),
  height: theme.typography.pxToRem(56),
  borderRadius: '50%',
  backgroundColor: theme.palette.action.hover,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1),
}));
